import i18n from "@/language/i18n";
import MONTH_WIDGETS from "@/configuration/widgets/MONTH_WIDGETS";
import SICK_NOTES_WIDGETS from "@/configuration/widgets/SICK_NOTES_WIDGETS";

const WORKING_TIME_MODULE_WINDOW_IDENTIFIER = Object.freeze({
    TIMETRACKING_MODULE_WINDOW_ID: 'timetracking',
    ATTENDANCE_TYPES_MODULE_WINDOW_ID: 'attendancetypes',
    OVERTIMETRIMS_MODULE_WINDOW_ID: 'overtimetrims',
    MONTH_OF_EMPLOYEES_MODULE_WINDOW_ID: 'monthOfEmployees',
    REOPEN_MONTH_MODULE_WINDOW_ID: 'reopenMonth',
    MONTH_CONFIRMATION_MODULE_WINDOW_ID: 'monthConfirmation',
    MONTH_BALANCE_OVERVIEW_MODULE_WINDOW_ID: 'balancechange',
    MONTH_STATUS_MODULE_WINDOW_ID: 'monthStatus',
    MONTHLY_EMPLOYEE_PROGRESS_MODULE_ID: 'monthlyEmployeeProgress',
    MONTHLY_ABSENCE_MODULE_ID: 'monthlyAbsence',
    MONTHLY_ABSENCE_CONFIGURATION_MODULE_ID: 'monthlyAbsenceConfiguration',
    SICK_NOTES_MODULE_WINDOW_ID: 'sickNotes',
    MONTHLY_VERIFICATION_MODULE_ID: 'monthlyVerificationView',
    ABSENCE_EXPORT_MODULE_ID: 'absenceExport',
    WORKING_DAY_CONFIGURATION_MODULE_ID: 'workingDayConfiguration',
    OPEN_PROCESSES_MODULE_ID: 'openProcesses',
});

export { WORKING_TIME_MODULE_WINDOW_IDENTIFIER };

export default {
    WORKING_TIME_GROUP_WRAPPER: {
        type: 'group',
        id: 'workingTimeManagement',
        label: i18n.t('ModuleRegistry.groups.workingTimeManagement.name'),
        children: [],
        icon: '$wTime',
        sidebarIcon: '$wNavWorkingTimeManagment'
    },
    CHILDREN: {
        TIMETRACKING_MODULE: {
            type: 'module',
            id: 'timetracking',
            windowIdentifierType: WORKING_TIME_MODULE_WINDOW_IDENTIFIER.TIMETRACKING_MODULE_WINDOW_ID,
            label: i18n.t('ModuleRegistry.groups.workingTimeManagement.timeTracking.label'),
            navigationImg: require('@/assets/navigation/items/icon_zeiterfassung.svg'),
            routerLink: '/timetracking'
        },
        ATTENDANCE_TYPES_MODULE: {
            type: 'module',
            id: 'attendanceTypes',
            windowIdentifierType: WORKING_TIME_MODULE_WINDOW_IDENTIFIER.ATTENDANCE_TYPES_MODULE_WINDOW_ID,
            label: i18n.t('ModuleRegistry.groups.workingTimeManagement.attendanceTypes.label'),
            navigationImg: require('@/assets/navigation/items/icon_zeiterfassung.svg'),
            routerLink: '/attendanceTypes'
        },
        OVERTIME_TRIM_MODULE: {
            type: 'module',
            id: 'overtimeTrimOverview',
            windowIdentifierType: WORKING_TIME_MODULE_WINDOW_IDENTIFIER.OVERTIMETRIMS_MODULE_WINDOW_ID,
            label: i18n.t('ModuleRegistry.groups.workingTimeManagement.overtimeTrimOverview.label'),
            navigationImg: require('@/assets/navigation/items/icon_abteilung.svg'),
            routerLink: '/overtimetrims',
            globalSearch: {
                index: 'overtimetrims'
            },
        },
        MONTH_OF_EMPLOYEES_MODULE: {
            type: 'module',
            id: 'monthOfEmployees',
            windowIdentifierType: WORKING_TIME_MODULE_WINDOW_IDENTIFIER.MONTH_OF_EMPLOYEES_MODULE_WINDOW_ID,
            label: i18n.t('ModuleRegistry.groups.workingTimeManagement.labels.overview'),
            navigationImg: require('@/assets/navigation/items/timetracking-item.png'),
            routerLink: '/monthOfEmployees',
            widgets: MONTH_WIDGETS.MONTH_OF_EMPLOYEES_WIDGETS
        },
        REOPEN_MONTH_MODULE: {
            type: 'module',
            id: 'reopenMonth',
            windowIdentifierType: WORKING_TIME_MODULE_WINDOW_IDENTIFIER.REOPEN_MONTH_MODULE_WINDOW_ID,
            label: i18n.t('ModuleRegistry.groups.workingTimeManagement.labels.reopenMonth'),
            navigationImg: require('@/assets/navigation/items/timetracking-item.png'),
            routerLink: '/reopenMonth',
        },
        MONTH_CONFIRMATION_MODULE: {
            type: 'module',
            id: 'monthConfirmation',
            windowIdentifierType: WORKING_TIME_MODULE_WINDOW_IDENTIFIER.MONTH_CONFIRMATION_MODULE_WINDOW_ID,
            label: i18n.t('ModuleRegistry.groups.workingTimeManagement.labels.confirmation'),
            navigationImg: require('@/assets/navigation/items/timetracking-item.png'),
            routerLink: '/monthConfirmation',
        },
        MONTH_BALANCE_MODULE: {
            type: 'module',
            id: 'monthBalanceOverview',
            windowIdentifierType: WORKING_TIME_MODULE_WINDOW_IDENTIFIER.MONTH_BALANCE_OVERVIEW_MODULE_WINDOW_ID,
            label: i18n.t('Month.words.balance'),
            navigationImg: require('@/assets/navigation/items/timetracking-item.png'),
            routerLink: '/balancechange',
        },
        MONTHLY_ABSENCE_MODULE: {
            type: 'module',
            id: 'monthlyAbsence',
            windowIdentifierType: WORKING_TIME_MODULE_WINDOW_IDENTIFIER.MONTHLY_ABSENCE_MODULE_ID,
            label: i18n.t('ModuleRegistry.groups.workingTimeManagement.labels.absence'),
            navigationImg: require('@/assets/navigation/items/timetracking-item.png'),
            routerLink: '/absence',
        },
        MONTHLY_ABSENCE_CONFIGURATION_MODULE: {
            type: 'module',
            id: 'monthlyAbsenceConfiguration',
            windowIdentifierType: WORKING_TIME_MODULE_WINDOW_IDENTIFIER.MONTHLY_ABSENCE_CONFIGURATION_MODULE_ID,
            label: i18n.t('ModuleRegistry.groups.absenceConfiguration.name'),
            navigationImg: require('@/assets/navigation/items/timetracking-item.png'),
            routerLink: '/monthlyAbsenceConfiguration',
        },
        SICK_NOTES_MODULE: {
            type: 'module',
            id: 'sickNotes',
            windowIdentifierType: WORKING_TIME_MODULE_WINDOW_IDENTIFIER.SICK_NOTES_MODULE_WINDOW_ID,
            label: i18n.t('ModuleRegistry.groups.workingTimeManagement.sickNotesView.label'),
            navigationImg: require('@/assets/navigation/items/icon_krankmeldung.svg'),
            routerLink: '/sicknotes',
            globalSearch: {
                index: 'sicknotes',
                presentation: i18n.t('ModuleRegistry.groups.workingTimeManagement.sickNotesView.presentation'),
                component: 'SickNoteItem.vue',
                shortcut: '-s'
            },
            widgets: SICK_NOTES_WIDGETS.SICK_NOTES_WIDGETS
        },
        MONTH_STATUS_MODULE: {
            type: 'module',
            id: 'monthstatus',
            windowIdentifierType: WORKING_TIME_MODULE_WINDOW_IDENTIFIER.MONTH_STATUS_MODULE_WINDOW_ID,
            label: i18n.t("MonthStatus.words.monthStatus"),
            navigationImg: require('@/assets/navigation/items/timetracking-item.png'),
            routerLink: '/monthstatus',
        },
        MONTHLY_VERIFICATION_MODULE: {
            type: 'module',
            id: 'monthlyVerificationView',
            windowIdentifierType: WORKING_TIME_MODULE_WINDOW_IDENTIFIER.MONTHLY_VERIFICATION_MODULE_ID,
            label: i18n.t('ModuleRegistry.groups.workingTimeManagement.labels.verification'),
            navigationImg: require('@/assets/navigation/items/timetracking-item.png'),
            routerLink: '/monthlyVerification',
        },
        MONTHLY_EMPLOYEE_PROGRESS_MODULE: {
            type: 'module',
            id: 'monthlyEmployeeProgress',
            windowIdentifierType: WORKING_TIME_MODULE_WINDOW_IDENTIFIER.MONTHLY_EMPLOYEE_PROGRESS_MODULE_ID,
            label: i18n.t('EmployeeMonthlyProgress.words.projectProgress'),
            navigationImg: require('@/assets/navigation/items/timetracking-item.png'),
            routerLink: '/monthly-employee-project-progress',
        },
        ABSENCE_EXPORT: {
            type: 'module',
            id: 'absenceExport',
            windowIdentifierType: WORKING_TIME_MODULE_WINDOW_IDENTIFIER.ABSENCE_EXPORT_MODULE_ID,
            label: i18n.t("AbsenceExport.words.absenceExport"),
            navigationImg: require('@/assets/navigation/items/timetracking-item.png'),
            routerLink: '/absenceExport',
        },
        WORKING_DAY_CONFIGURATION: {
            type: 'module',
            id: 'workingDayConfiguration',
            windowIdentifierType: WORKING_TIME_MODULE_WINDOW_IDENTIFIER.WORKING_DAY_CONFIGURATION_MODULE_ID,
            label: i18n.t('ModuleRegistry.groups.workingTimeManagement.labels.workingDayConfiguration'),
            navigationImg: require('@/assets/navigation/items/timetracking-item.png'),
            routerLink: '/workingDayConfiguration',
        },
        WORKING_HOURS_IMPORT_MODULE: {
            type: 'module',
            id: 'workinghoursimport',
            windowIdentifierType: WORKING_TIME_MODULE_WINDOW_IDENTIFIER.WORKING_HOURS_IMPORT_MODULE_ID,
            label: i18n.t('Timetracking.words.workingTimeImport'),
            navigationImg: require('@/assets/navigation/items/timetracking-item.png'),
            routerLink: '/workinghoursimport',
        },
        OPEN_PROCESSES: {
            type: 'module',
            id: 'openProcesses',
            windowIdentifierType: WORKING_TIME_MODULE_WINDOW_IDENTIFIER.OPEN_PROCESSES_MODULE_ID,
            label: i18n.t('OpenProcesses.words.openProcesses'),
            navigationImg: require('@/assets/navigation/items/timetracking-item.png'),
            routerLink: '/openProcesses',
        }    
    }
}